import { Button, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { blue } from '@material-ui/core/colors';

type FormActionsProps = {
  submitForm: () => void;
  onDelete?: () => void;
  isSubmitting?: boolean;
  isDeletable?: boolean;
};

export function FormActions({ submitForm, onDelete, isSubmitting = false, isDeletable = false }: FormActionsProps) {
  const history = useHistory();

  const handleCancel = () => {
    history.goBack();
  };

  return (
    <Grid container spacing={2} style={{ padding: '16px' }}>
      <Grid item>
        <Button
          variant="contained"
          color="primary"
          onClick={submitForm}
          disabled={isSubmitting}
          style={{ backgroundColor: blue[600] }}
        >
          {isSubmitting ? 'Creating...' : 'Create P2C Relation'}
        </Button>
      </Grid>
      <Grid item>
        <Button variant="outlined" onClick={handleCancel} disabled={isSubmitting}>
          Cancel
        </Button>
      </Grid>
      {isDeletable && onDelete && (
        <Grid item>
          <Button variant="outlined" color="secondary" onClick={onDelete} disabled={isSubmitting}>
            Delete
          </Button>
        </Grid>
      )}
    </Grid>
  );
} 